  <div class="row mb-3">
    <div class="col-lg-3">
        <ng-content select="[side-panel]"></ng-content>
    </div>
    <div class="col-lg-9 ps-0">
      <ng-content select="[content]"></ng-content>
    </div>
  </div>
